type PermitFile = {
    id: number;
    name?: string;
    file_name?: string;
};

export default {
    recordRepresentation: (record: PermitFile) =>
        record?.name || record?.file_name || `Permit file #${record?.id ?? ''}`,
};
